import { dispatcher } from 'lib/Dispatcher';
import { ErrorTypes } from 'constants/ErrorConstants';

const ErrorActions = {
  expiredToken(context: string) {
    dispatcher.dispatch({
      type: ErrorTypes.EXPIRED_TOKEN,
      context,
    });
  },

  unknownToken(context: string) {
    dispatcher.dispatch({
      type: ErrorTypes.UNKNOWN_TOKEN,
      context,
    });
  },

  serverError(error: Object) {
    dispatcher.dispatch({
      type: ErrorTypes.SERVER_ERROR,
      error,
    });
  },
};

export default ErrorActions;
